import React from "react";
import { Select } from "antd";
import ReactCountryFlag from "react-country-flag";

class BrdgxCountrySelector extends React.Component {
  render() {
    const countries = this.props.countries;
    return (
      <Select
        showSearch
        style={{ width: 200, ...this.props.style }}
        size={this.props.size}
        placeholder={this.props.placeholder}
        optionFilterProp="children"
        onChange={this.props.onChange}
        value={this.props.value || undefined}
        // filterOption={(input, option) =>
        //   option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        // }
        mode={this.props.mode || "default"}
      >
        {countries.map((country) => {
          return (
            <Select.Option value={country.countryCode} key={country.countryCode}>
              <ReactCountryFlag code={country.isoCodeAlpha2} />
                &nbsp;{country.country}
            </Select.Option>
          );
        })}
      </Select>
    );
  }
}

export default BrdgxCountrySelector;
